// Accessory unlock levels + labels
export const ACCESSORIES = [
  { id: "bow", label: "Pita Merah", reqLevel: 1 },
  { id: "flower", label: "Bunga", reqLevel: 2 },
  { id: "glasses", label: "Kacamata", reqLevel: 3 },
  { id: "hat", label: "Topi Piknik", reqLevel: 4 },
  { id: "crown", label: "Mahkota", reqLevel: 5 },
  { id: "scarf", label: "Syal Musim", reqLevel: 6 },
  { id: "balloon", label: "Balon", reqLevel: 7 },
];

export const xpForLevel = (lvl) => lvl * 100;

export const unlockedAccessories = (level) =>
  ACCESSORIES.filter((a) => a.reqLevel <= level).map((a) => a.id);

// Derive base mood from stats
export function baseMood(m) {
  if (!m.alive) return "dead";
  if (m.kesehatan <= 20) return "sick";
  if (m.energi <= 12) return "tired";
  if (m.kenyang <= 20) return "hungry";
  if (m.bahagia <= 30) return "sad";
  if (m.bahagia >= 80 && m.kenyang >= 60 && m.energi >= 55) return "joy";
  return "happy";
}

export const MOOD_LABELS = {
  happy: "Bahagia", joy: "Senang", hungry: "Lapar", eating: "Makan",
  tired: "Lelah", sleep: "Tidur", sick: "Sakit", sad: "Sedih",
  play: "Bermain", cuddle: "Dielus", dead: "Pingsan", revive: "Bangkit!", levelup: "Naik level!", cheek: "Dielus",
};

export const MOOD_SPEECH = {
  happy: ["Dekat kalian rasanya nyaman.", "Hari ini menyenangkan ya.", "Prrr… aku senang."],
  joy: ["Yeay! Aku bahagia banget!", "Kalian yang terbaik!", "Senangnyaaa~"],
  hungry: ["Perutku keroncongan…", "Ada cemilan nggak?", "Lapar niih."],
  eating: ["Nyam nyam… enak!", "Makasih makanannya!", "Hmm lezat~"],
  tired: ["Aku ngantuk…", "Capek, pengen rebahan.", "Energiku menipis."],
  sleep: ["Zzz… mimpi indah.", "Tidur dulu ya…", "Zzz…"],
  sick: ["Badanku nggak enak…", "Aku butuh obat.", "Uhuk… kurang sehat."],
  sad: ["Aku kangen diajak main…", "Sedih nih…", "Peluk dong."],
  play: ["Wii! Seru!", "Lagi dong mainnya!", "Hehe geli!"],
  cuddle: ["Prrr… jangan berhenti dulu.", "Elusannya enak…", "Nyaman banget."],
  dead: ["…", "(butuh dibangkitkan)", "…"],
  revive: ["Aku kembali! ✨", "Terima kasih sudah menolongku!", "Bangkit lagi!"],
  levelup: ["Yeay! Aku naik level! 🎉", "Aku makin hebat berkat kalian!", "Pesta! Pesta!"],
  cheek: ["Meong~ geli!", "Hehe, pipiku…", "Prrr… lagi dong."],
};

export function randomSpeech(mood) {
  const arr = MOOD_SPEECH[mood] || MOOD_SPEECH.happy;
  return arr[Math.floor(Math.random() * arr.length)];
}

// Kostum musiman (menempel di badan, slot terpisah dari aksesori kepala)
export const COSTUMES = [
  { id: "rain", label: "Jas Hujan", emoji: "🌧️", reqLevel: 2, months: [11, 12, 1, 2, 3], note: "Musim hujan" },
  { id: "lebaran", label: "Baju Lebaran", emoji: "🌙", reqLevel: 4, months: [3, 4], note: "Idulfitri" },
  { id: "natal", label: "Syal Natal", emoji: "🎄", reqLevel: 6, months: [12], note: "Natal" },
  // Kostum kupon kencan: terbuka setelah menyelesaikan kencan bertema (kategori destinasi)
  { id: "explorer", label: "Rompi Petualang", emoji: "🧭", dateCategory: "Wisata Alam", note: "Kencan Wisata Alam" },
  { id: "chef", label: "Celemek Chef", emoji: "🍳", dateCategory: "Restaurant", note: "Kencan Restaurant" },
  { id: "gala", label: "Jas Gala", emoji: "🎩", dateCategory: "Museum", note: "Kencan Museum" },
];
export const costumeUnlocked = (c, level, cats = [], d = new Date()) =>
  c.dateCategory ? cats.includes(c.dateCategory) : level >= c.reqLevel || c.months.includes(d.getMonth() + 1);
export const petName = (m) => (m && m.name ? m.name : "Mochi");
// Balasan saat nama dipanggil / obrolan
export const NAME_REPLIES = ["Iya? Aku di sini! 🐾", "Meong~ ada apa, sayang?", "Kalian panggil aku? Hehe~", "Prrr… aku dengar kok!"];
export const CHAT_REPLIES = ["Prrr…", "Meong?", "Aku dengerin kok~", "Ceritain lagi dong.", "Hehe, kalian lucu."];
